export const environment = {
  production: true,
  tenantDomain: 'smartcapacity.dev',
  version: '1.0.0.628DC9F',
  sha: '628DC9F',
};
